import { render, staticRenderFns } from "./setbankcard.vue?vue&type=template&id=7ec722b6&scoped=true&"
import script from "./setbankcard.vue?vue&type=script&lang=js&"
export * from "./setbankcard.vue?vue&type=script&lang=js&"
import style0 from "./setbankcard.vue?vue&type=style&index=0&id=7ec722b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec722b6",
  null
  
)

export default component.exports